import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64e28f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { key: 0 }

import { SelectItem } from '@/types/SelectItem';
import AppBottomBar from '@/components/AppBottomBar.vue';
import TWysiwyg, { MediaFile, TWysiwygResponse } from '@/components/Wysiwyg/TWysiwyg.vue';
import {
  DEFAULT_APP_LOCALE,
  DEVICE_LANGUAGES,
  DEVICE_PLATFORMS,
  DEVICE_PLATFORMS_ARRAY,
  PROVIDE_KEYS,
  VERSION_ADDITITIONALLY_CHAR,
  VERSION_FORMAT_REGEX,
  VERSION_JOIN_DELIMITER,
  VERSION_SPLIT_DELIMITER
} from '@/utils/constants';
import { SEND_NOTIFICATION, SUBMIT_FORM } from '@/utils/events';
import { getTranslateLangByLocale } from '@/utils/functions';
import useVuelidate from '@vuelidate/core';
import { helpers, required } from '@vuelidate/validators';
import { inject, reactive } from 'vue';
import { useI18n } from 'vue-i18n';

enum VERSION_VARIANT {
  SINGLE = 'single',
  GROUP = 'group'
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationForm',
  props: {
  inProcess: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object
  },
  edit: {
    type: Boolean,
    default: false
  }
},
  emits: [SUBMIT_FORM, SEND_NOTIFICATION],
  setup(__props, { emit: __emit }) {

const { showSnackbar }: any = inject(PROVIDE_KEYS.SNACKBAR);

const emit = __emit;
const { t } = useI18n();
const props = __props;
const localData = reactive({
  modeEdit: props.edit,
  platforms: DEVICE_PLATFORMS_ARRAY,
  devicePlatforms: DEVICE_PLATFORMS,
  selectPlatformItems: Object.values(DEVICE_PLATFORMS).map((value) => ({
    title: value as string,
    translate: value == DEVICE_PLATFORMS.All ? t('TextField.All') : (value as string)
  })),
  unusedLocales: [] as SelectItem[],
  selectedLocale: '',
  existedLangs: [] as string[],
  versionVariant: undefined,
  canSend: props.formData?.sentAt == null
});

const preFormData = localData.modeEdit
  ? {
    title: props.formData?.title,
    platform: props.formData?.platform == null ? localData.devicePlatforms.All : props.formData?.platform,
    notification: {} as Record<string, string>,
    metadata: JSON.parse(props.formData?.metadata),
    withPush: props.formData?.withPush,
    versions: props.formData?.versions != null ? JSON.parse(props.formData?.versions).join(',') : '',
    minVersion: props.formData?.minVersion ?? '',
    maxVersion: props.formData?.maxVersion ?? '',
    mediaFiles: {} as Record<string,MediaFile[]>
  }
  : {
    title: '',
    platform: localData.devicePlatforms.All as string,
    notification: {} as Record<string, string>,
    metadata: {},
    withPush: false,
    versions: '',
    minVersion: '',
    maxVersion: '',
    mediaFiles: {} as Record<string,MediaFile[]>
  };

const formDataLocal = reactive(preFormData);

if (!localData.modeEdit) {
  addLocale(DEFAULT_APP_LOCALE);
} else {
  if (props.formData?.content) {
    const contentObj = JSON.parse(props?.formData?.content);
    Object.keys(contentObj).map((_keyLang: string) => {
      formDataLocal.notification[_keyLang] = contentObj[_keyLang];
    });
    rebuildUnusedLocales();
  }

  if (formDataLocal.versions.length > 0) {
    localData.versionVariant = VERSION_VARIANT.SINGLE as any;
  } else if (formDataLocal.minVersion.length > 0 && formDataLocal.maxVersion.length > 0) {
    localData.versionVariant = VERSION_VARIANT.GROUP as any;
  } else {
    localData.versionVariant = undefined;
  }
}

const groupCustomRequire = (value: string) => {
  return localData.versionVariant == VERSION_VARIANT.GROUP ? value.trim().length > 0 : true;
};

const singleCustomRequire = (value: string) => {
  return localData.versionVariant == VERSION_VARIANT.SINGLE ? value.trim().length > 0 : true;
};

const versionFormat = (value: string) => {
  return localData.versionVariant == VERSION_VARIANT.GROUP ? VERSION_FORMAT_REGEX.test(value) : true;
};

const lessBefore = (value: string): boolean => {
  let beforeString = formDataLocal.maxVersion.split(VERSION_SPLIT_DELIMITER).join(VERSION_JOIN_DELIMITER);
  let fromString = value.split(VERSION_SPLIT_DELIMITER).join(VERSION_JOIN_DELIMITER);
  const beforeStringLength = beforeString.length;
  const fromStringLength = fromString.length;
  if (beforeStringLength > fromStringLength) {
    fromString = fromString.padEnd(beforeStringLength, VERSION_ADDITITIONALLY_CHAR);
  } else if (beforeStringLength < fromStringLength) {
    beforeString = beforeString.padEnd(fromStringLength, VERSION_ADDITITIONALLY_CHAR);
  }
  const before = Number(beforeString);
  const from = Number(fromString);
  return localData.versionVariant == VERSION_VARIANT.GROUP ? from < before : true;
};

const greateFrom = (value: string): boolean => {
  let beforeString = value.split(VERSION_SPLIT_DELIMITER).join(VERSION_JOIN_DELIMITER);
  let fromString = formDataLocal.minVersion.split(VERSION_SPLIT_DELIMITER).join(VERSION_JOIN_DELIMITER);

  const beforeStringLength = beforeString.length;
  const fromStringLength = fromString.length;
  if (beforeStringLength > fromStringLength) {
    fromString = fromString.padEnd(beforeStringLength, VERSION_ADDITITIONALLY_CHAR);
  } else if (beforeStringLength < fromStringLength) {
    beforeString = beforeString.padEnd(fromStringLength, VERSION_ADDITITIONALLY_CHAR);
  }

  const before = Number(beforeString);
  const from = Number(fromString);
  return localData.versionVariant == VERSION_VARIANT.GROUP ? before > from : true;
};

const rules = {
  title: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.Theme') }), required)
  },
  versions: {
    singleCustomRequire: helpers.withMessage(
      t('TextFieldError.Required', { field: t('TextField.Versions') }),
      singleCustomRequire
    )
  },
  minVersion: {
    groupCustomRequire: helpers.withMessage(
      t('TextFieldError.Required', { field: t('TextField.Start') }),
      groupCustomRequire
    ),
    versionFormat: helpers.withMessage(t('TextFieldError.BadFormat', { field: t('TextField.Start') }), versionFormat),
    lessBefore: helpers.withMessage(
      t('TextFieldError.MustLessThen', { child: t('TextField.Start'), parent: t('TextField.End') }),
      lessBefore
    )
  },
  maxVersion: {
    groupCustomRequire: helpers.withMessage(
      t('TextFieldError.Required', { field: t('TextField.End') }),
      groupCustomRequire
    ),
    versionFormat: helpers.withMessage(t('TextFieldError.BadFormat', { field: t('TextField.End') }), versionFormat),
    greateFrom: helpers.withMessage(
      t('TextFieldError.MustMoreThen', { child: t('TextField.End'), parent: t('TextField.Start') }),
      greateFrom
    )
  }
};
const v$ = useVuelidate(rules, formDataLocal);

function generateFieldErrors(_fieldName: string) {
  return v$.value[_fieldName].$errors.map((errorItem: any) => errorItem.$message);
}

function onChangeVersionVariant() {
  if (localData.versionVariant == undefined) {
    formDataLocal.versions = '';
    formDataLocal.minVersion = '';
    formDataLocal.maxVersion = '';
  } else if (localData.versionVariant == VERSION_VARIANT.SINGLE) {
    formDataLocal.minVersion = '';
    formDataLocal.maxVersion = '';
  } else if (localData.versionVariant == VERSION_VARIANT.GROUP) {
    formDataLocal.versions = '';
  }
}

async function onClick(send: boolean) {
  if (await v$.value.$validate()) {
    if (
      !Object.keys(formDataLocal.notification).includes(DEFAULT_APP_LOCALE) ||
      formDataLocal.notification[DEFAULT_APP_LOCALE].length === 0
    ) {
      showSnackbar('ErrorMessage.Notification.HasDefaultTranslate');
      return false;
    } else {     
      emit(SUBMIT_FORM, { formData: formDataLocal, localData, send });
    }
  } else {
    return false;
  }
}

function addLocale(_newLocale: string): void {
  formDataLocal.notification[_newLocale] = '';
  rebuildUnusedLocales();
}
function rebuildUnusedLocales(): void {
  localData.existedLangs = Object.keys(formDataLocal.notification);

  const avaliableLocaleTranslations: SelectItem[] = [];
  DEVICE_LANGUAGES.map((locale) => {
    if (!localData.existedLangs.includes(locale.lang)) {
      avaliableLocaleTranslations.push({
        title: locale.translation,
        value: locale.lang
      });
    }
  });
  localData.unusedLocales = avaliableLocaleTranslations;
  if (avaliableLocaleTranslations.length > 0) {
    localData.selectedLocale = avaliableLocaleTranslations[0].value;
  }
}
function getLabel(_locale: string): string {
  return getTranslateLangByLocale(_locale);
}
function onChangeTwysiwyg(lang: string, data: TWysiwygResponse) {
  formDataLocal.notification[lang] = data.content;  
  if(!Object.keys(formDataLocal.metadata).includes('formatting')){
    formDataLocal.metadata.formatting = {};
  }
  formDataLocal.metadata.formatting[lang] = data.format;
  if(data.media){
    formDataLocal.mediaFiles[lang] = data.media;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataLocal.title) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    class: "py-1",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.Theme'),
                    "error-messages": generateFieldErrors('title'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "4"
              }, {
                default: _withCtx(() => [
                  (localData.unusedLocales.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_select, {
                          modelValue: localData.selectedLocale,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.selectedLocale) = $event)),
                          "no-message": "",
                          variant: "outlined",
                          color: "primary",
                          "bg-color": "input-background",
                          class: "small-size",
                          items: localData.unusedLocales,
                          label: _ctx.$t('TextField.Locale')
                        }, null, 8, ["modelValue", "items", "label"]),
                        _createVNode(_component_v_btn, {
                          class: "ml-4 add-btn-small",
                          variant: "flat",
                          color: "primary",
                          icon: "mdi-plus",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (addLocale(localData.selectedLocale)))
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: _normalizeClass({ 'mb-13': Object.keys(formDataLocal.notification).length >= 3 })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localData.existedLangs, (lang) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: lang,
                      class: "list-notifications__input"
                    }, [
                      _createVNode(TWysiwyg, {
                        label: getLabel(lang),
                        "use-editor": localData.canSend,
                        class: "pb-14",
                        content: { content: formDataLocal.notification[lang], format: formDataLocal.metadata?.formatting ? formDataLocal.metadata.formatting[lang] : {}},
                        onChange: (data) => onChangeTwysiwyg(lang, data)
                      }, null, 8, ["label", "use-editor", "content", "onChange"])
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }),
      _createVNode(AppBottomBar, { class: "justify-space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_switch, {
            modelValue: formDataLocal.withPush,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataLocal.withPush) = $event)),
            color: "primary",
            class: "switch-push",
            "hide-details": ""
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Label.WithPush')), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (localData.canSend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "mr-4",
                  variant: "flat",
                  disabled: __props.inProcess,
                  loading: __props.inProcess,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (onClick(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(localData.modeEdit ? _ctx.$t('Button.Save') : _ctx.$t('Button.Create')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "my-2 my-xs-0",
                  variant: "flat",
                  disabled: __props.inProcess,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (onClick(true)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(localData.modeEdit ? _ctx.$t('Button.Send') : _ctx.$t('Button.SaveAndSend')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})